/**
 * Direktive zum Initialisieren und Aufräumen von Timeline
 * @class directive_v3sTimeline
 * @memberOf v3sWbtPlayerApp:animation
 * @requires {@link v3sWbtPlayerApp:animation.service_v3sTimelineService}
 */
angular.module('v3sWbtPlayerApp').directive('v3sTimeline', ["v3sTimelineService", "v3sMediaService", function (v3sTimelineService, v3sMediaService) {
    return {
        restrict: 'E',
        controller: ["$scope", function ($scope) {
            v3sTimelineService.init();

            $scope.$on('$destroy', function () {
                v3sTimelineService.destroy();
            });
        }],
        link: function (scope, element) {
            var handler = null;
            var animatedElements = null;

            v3sMediaService.prepareMedia().then(function () {
                //Die ClassAnimation für den Pageview wird nur bei Navigation durchgeführt.
                //Damit die Timeline auch beim ersten laden des Kurses gestartet wird, prüfen wir hier,
                //ob die ClassAnimation und somit die entsprechenden Events gestartet wurden.

                animatedElements = document.querySelectorAll("div[v3s-page-view][data-ng-animate='1']");

                //Keine animierten Elemente
                if (animatedElements.length == 0) {
                    v3sTimelineService.play();
                } else {
                //Animation läuft => warten
                    scope.$on("v3sPageEnterAnimationCompleted", function () {
                        v3sTimelineService.play();
                    });
                }
            });
        }
    }
}]);